import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  username: yup
    .string().min(3, 'Minimo 3 caractéres.')
    .required('Favor ingresar tu nombre'),
  phone: yup
    .string()
    .required('Favor ingresar tu teléfono'),
  email: yup
    .string()
    .email('Ingrese un email válido.')
    .required('Favor ingresar tu correo')
});